import {translate} from "../../../../../helper/translate";

class VariationManager {
    runs = [
        {
            value: 0,
            name: translate('No Change'),
        },
        {
            value: 0.2,
            name: translate('Slight Change'),
        },
        {
            value: .75,
            name: translate('Large Change'),
        },
        {
            value: 1,
            name: translate('Very Large Change'),
        },
    ];

    constructor() {
    }

    getByName(name) {
        return this.runs.find(runs => runs.name === name);
    }

    getByValue(value) {
        return this.runs.find(runs => runs.value === value);
    }
}

export default new VariationManager()
